import { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { toast } from 'sonner';
import { Dumbbell, Loader2 } from 'lucide-react';
import { useAuth } from '@/lib/auth';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { Card } from '@/components/ui/card';

export default function Register() {
    const { register } = useAuth();
    const navigate = useNavigate();
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [name, setName] = useState('');
    const [loading, setLoading] = useState(false);

    const submit = async (e) => {
        e.preventDefault();
        if (password.length < 6) { toast.error('La contraseña debe tener al menos 6 caracteres'); return; }
        setLoading(true);
        try {
            await register(email, password, name);
            toast.success('Cuenta creada. ¡Vamos a entrenar!');
            navigate('/');
        } catch (err) {
            toast.error(err.response?.data?.detail || 'No se pudo crear la cuenta');
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="min-h-screen hero-wash app-bg-noise flex items-center justify-center px-4">
            <div className="w-full max-w-md">
                <div className="flex items-center gap-3 mb-6 justify-center">
                    <div className="h-11 w-11 rounded-xl bg-[hsl(var(--primary))] grid place-items-center">
                        <Dumbbell className="h-6 w-6 text-[hsl(var(--primary-foreground))]" />
                    </div>
                    <div className="font-display font-semibold text-2xl tracking-tight">FitHome</div>
                </div>
                <Card className="bg-card border-border p-6">
                    <h1 className="text-2xl font-semibold mb-1 font-display">Crear cuenta</h1>
                    <p className="text-sm text-muted-foreground mb-6">Tu rutina, tu progreso, tu ritmo.</p>
                    <form onSubmit={submit} className="space-y-4">
                        <div>
                            <Label htmlFor="name">Nombre</Label>
                            <Input id="name" value={name} onChange={(e) => setName(e.target.value)} required data-testid="auth-name-input" className="mt-1" />
                        </div>
                        <div>
                            <Label htmlFor="email">Email</Label>
                            <Input id="email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} required data-testid="auth-email-input" className="mt-1" />
                        </div>
                        <div>
                            <Label htmlFor="password">Contraseña</Label>
                            <Input id="password" type="password" value={password} onChange={(e) => setPassword(e.target.value)} required placeholder="mínimo 6 caracteres" data-testid="auth-password-input" className="mt-1" />
                        </div>
                        <Button type="submit" className="w-full h-12 text-base" disabled={loading} data-testid="auth-submit-button">
                            {loading ? <Loader2 className="h-4 w-4 animate-spin" /> : 'Crear cuenta'}
                        </Button>
                    </form>
                    <div className="mt-6 text-sm text-muted-foreground text-center">
                        ¿Ya tienes cuenta?{' '}
                        <Link to="/login" className="text-[hsl(var(--primary))] hover:underline" data-testid="go-login-link">Inicia sesión</Link>
                    </div>
                </Card>
            </div>
        </div>
    );
}
